import React, { useCallback } from 'react';

import {
	ConfigFieldDropdown,
	type FieldOption,
	type RenderVariant,
} from '@atlassian/company-hub-common';

import { CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE } from '../../../../constants';
import type { UpdateMainFormFieldType } from '../../../../controllers/use-cards-extension-parameters-and-actions/types';
import { type CardSize } from '../../../../types';

import { SIZE_OPTIONS_CARDS } from './constants';
import { messages } from './messages';

type SizeFieldProps = {
	renderVariant: RenderVariant;
	showUpdatedStyles?: boolean;
	sizeParameter: CardSize;
	updateMainFormField: UpdateMainFormFieldType;
};

export const SizeField = ({
	sizeParameter,
	renderVariant,
	updateMainFormField,
	showUpdatedStyles,
}: SizeFieldProps): React.JSX.Element => {
	const { sizeOptions, selectedOption } = {
		sizeOptions: SIZE_OPTIONS_CARDS,
		selectedOption:
			SIZE_OPTIONS_CARDS.find(({ value }) => value === sizeParameter) || SIZE_OPTIONS_CARDS[0],
	};

	const handleSelect = useCallback(
		(selectedLabel: FieldOption<CardSize>) => {
			updateMainFormField({ size: selectedLabel.value });
		},
		[updateMainFormField],
	);

	return (
		<ConfigFieldDropdown<CardSize>
			fieldType="size"
			label={messages.sizeTextLabel}
			onSelect={handleSelect}
			options={sizeOptions}
			selectedOption={selectedOption}
			renderVariant={renderVariant}
			showUpdatedStyles={showUpdatedStyles}
			source={CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE}
		/>
	);
};
